var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwdCheckTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 10.866 10.866 14 7 14C3.13399 14 0 10.866 0 7C0 3.13399 3.13399 0 7 0C10.866 0 14 3.13399 14 7ZM6.19033 10.7064L11.3839 5.5129C11.5602 5.33654 11.5602 5.05058 11.3839 4.87423L10.7452 4.23557C10.5688 4.05918 10.2829 4.05918 10.1065 4.23557L5.87096 8.47105L3.89349 6.49361C3.71714 6.31727 3.43118 6.31727 3.2548 6.49361L2.61614 7.13224C2.43978 7.30864 2.43978 7.59459 2.61614 7.77093L5.55162 10.7064C5.72801 10.8828 6.01393 10.8828 6.19033 10.7064Z",
    fill: "#1ABC9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdCheckTick);
export default __webpack_public_path__ + "static/media/pwd-check-tick.ad243661b31475b5a73adf6df69ccf77.svg";
export { ForwardRef as ReactComponent };